import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './ProjectInvitationAskQuestion.scss';

class ProjectInvitationAskQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      submitted: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    this.setState({ message: target.value });
  }

  handleSubmit() {
    const { formUrl, csrfToken } = this.props;
    const { message } = this.state;

    return putRequest(
      formUrl,
      { status: 'questioned', message },
      csrfToken,
    ).then(() => {
      this.setState({ submitted: true });
    });
  }

  render() {
    const { message, submitted } = this.state;
    return (
      <ModalTrigger
        triggerText="Have a question?"
        buttonStyles="secondary full-width"
        submitButtonText="Send"
        handleSubmit={this.handleSubmit}
        submitDisabled={!message}
        cancelButton={false}
        idKey="ask-question-on-project-invitation-modal"
        showFooter={!submitted}
      >
        {submitted
          ? (
            <div className="style-guide">
              <h1 className="mb-8">Your questions were sent!</h1>
              <div className="body-text-2 mb-25">
                Clora will follow up shortly via email with next steps.
              </div>
            </div>
          )
          : (
            <div className="style-guide">
              <h1 className="mb-8">Questions</h1>
              <div className="body-text-2 mb-3 ">
                Ask any questions you have about this project. Clora will triage your questions
                to the hiring manager.
              </div>
              <textarea
                value={message}
                className="form-control"
                placeholder="Type here..."
                name="message"
                id="message"
                rows="4"
                onChange={this.handleInputChange}
              />
            </div>
          )}
      </ModalTrigger>
    );
  }
}

ProjectInvitationAskQuestion.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
};

export default ProjectInvitationAskQuestion;
